import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/Button';
import { ModuleId } from '../../content';
import { GroupId } from '../../config/systemConfig';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
import { DjayNarrator } from '../../mascot';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
interface ValidationErrorModalProps {
  error: {
    moduleId: ModuleId;
    message: string;
    hasContent: boolean;
  };
  selectedGroup: GroupId;
  onClose: () => void;
  onNavigateToModules: () => void;
}
export function ValidationErrorModal({
  error,
  selectedGroup,
  onClose,
  onNavigateToModules
}: ValidationErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onClose);
  // F-FEEL-1 + F-FEEL-2: announce the validation block once, audibly + tactilely
  useEffect(() => {
    soundManager.playError();
    hapticManager.hapticError();
  }, []);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-2631" data-mp="1mxxgqain6df4" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-2632" data-mp="1d61imzgk2naw">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="validation-error-title" className="bg-white rounded-3xl shadow-2xl shadow-indigo-100 max-w-md w-full p-8 border-2 border-slate-100 relative overflow-hidden" data-id="element-2633" data-mp="1d3yj9otijhti">
          {/* Decorative background blur */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-indigo-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2634" data-mp="u6dv6jykon9y" />

          <div className="text-center relative z-10" data-id="element-2635" data-mp="pa705m7psw6s">
            {/* Djay Avatar */}
            <div className="flex justify-center mb-4" data-id="element-2636" data-mp="2okf3rwjxcon8">
              <DjayNarrator size="lg" emotion="thinking" animate data-id="element-2637" data-mp="2jllmru5fifib" />
            </div>

            <h2 id="validation-error-title" className="text-2xl font-black text-slate-900 mb-2 tracking-tight" data-id="element-2638" data-mp="hx7oqiw8zjag">
              Hmm, even geduld!
            </h2>
            <p className="text-slate-600 font-medium mb-6 leading-relaxed" data-id="element-2639" data-mp="7z08y3dp37a1">
              Voor dit onderwerp zijn er nog geen oefenvragen beschikbaar in
              groep {selectedGroup}. Probeer een ander onderwerp!
            </p>

            <div className="flex flex-col gap-3" data-id="element-2640" data-mp="10oqqkmejcraw">
              <Button onClick={onClose} variant="primary" size="xl" fullWidth className="shadow-lg shadow-indigo-200/50 rounded-2xl" data-id="element-2641" data-mp="15migjavme3cg">
                <ArrowLeft className="w-5 h-5 mr-2" data-id="element-2642" data-mp="vnjh8iwqvk24" />
                Terug
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}